export enum ChallengeType {
  Email = 'Email',
  Passcode = 'Passcode',
}

export type SharingAccessErrorCode =
  | 'linkExpired'
  | 'invalidErrorCode'
  | 'notFound'
  | 'wrongDevice'
  | 'invalidPasscode';

export default { ChallengeType };
